var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "application-career-characteristic-edit",
        { "has-items": _vm.hasItems }
      ]
    },
    [
      _c("div", { staticClass: "left" }, [
        _c("div", { staticClass: "left1" }, [
          _c(
            "span",
            { staticClass: "icon-container" },
            [
              _c("Icon", {
                attrs: { icon: _vm.hasItems ? "checkmark" : "question-mark" }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "left2" },
          [
            _vm.hasItems
              ? [
                  _c("SelectedItems", {
                    staticClass: "no-left-padding",
                    attrs: {
                      "characteristic-items":
                        _vm.editConfig.characteristicItems,
                      "characteristic-type": _vm.editConfig.characteristicType,
                      selected: _vm.items
                    }
                  })
                ]
              : [
                  _c(
                    "a",
                    {
                      attrs: { href: "#" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.openFan.apply(null, arguments)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.openFanLabel))]
                  )
                ]
          ],
          2
        )
      ]),
      _vm._v(" "),
      _vm.hasItems
        ? _c("div", { staticClass: "actions" }, [
            _c(
              "a",
              {
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.openFan.apply(null, arguments)
                  }
                }
              },
              [_c("Icon", { attrs: { icon: "pencil" } })],
              1
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }